import React from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import get from 'lodash/get';
import VisibilitySensor from 'react-visibility-sensor';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import StructureModel from '@Components/Results/structure/structure-model.service';
import ReactionView from '@Components/Results/reactions/ReactionView';
import ReactionDetailsComponent from '@Components/Results/reactions/reaction-details/reaction-details.component';

import './Reaction.scss';

export default class Reaction extends React.Component {
  constructor(props) {
    super(props);

    const { metadata, databaseId, originalSearchType, reaction } = props;

    // This will add extra stuff like rxnFile, rxnPath, etc. for the toolbar buttons
    this.state = {
      metadata: {
        ...metadata,
        databaseId,
        originalSearchType,
        ...omit(reaction, ['reactants', 'products', 'hitDetails', 'details']),
      },
      reactants: this.convertToListOfStructureModels(reaction.reactants),
      products: this.convertToListOfStructureModels(reaction.products),
    };
  }

  convertToListOfStructureModels(structures = []) {
    const { reaction } = this.props;
    const { databaseId, index } = reaction;
    return structures.map((structure) => {
      // eslint-disable-next-line no-param-reassign
      structure.databaseId = databaseId;
      // eslint-disable-next-line no-param-reassign
      structure.index = index;
      return new StructureModel(structure);
    });
  }

  render() {
    const { metadata, reactants, products } = this.state;
    const {
      reaction,
      spinnerId,
      databaseId,
      documentResults,
      showToolbar,
      displayAllConditions,
      size,
      zoom: propsZoom,
      metadata: propsMetadata,
    } = this.props;
    const { isViewPreview } = propsMetadata || {};
    const zoom = isViewPreview ? 0 : propsZoom;
    const content = (
      <div className="reaction-content">
        <div className="clearfix reactions-wrapper">
          <ReactionView
            metadata={metadata}
            reactants={reactants}
            products={products}
            zoom={zoom}
            showToolbar={showToolbar}
            reactionId={reaction?.id}
          />
        </div>
        <ReactionDetailsComponent
          metadata={metadata}
          reaction={reaction}
          spinnerId={spinnerId}
          databaseId={databaseId}
          documentResults={documentResults}
          displayAllConditions={displayAllConditions}
        />
      </div>
    );

    if (!size || size <= 30 || get(metadata, 'fromRT')) {
      return content;
    }

    return (
      <VisibilitySensor partialVisibility offset={{ top: -1000, bottom: -1000 }}>
        {({ isVisible }) => {
          if (!isVisible) {
            return (
              <div className="rx-element-content notVisible">
                <div className="clearfix reactions-wrapper" />
              </div>
            );
          }

          return content;
        }}
      </VisibilitySensor>
    );
  }
}

Reaction.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  showToolbar: true,
  displayAllConditions: true,
};

Reaction.propTypes = {
  metadata: MetadataPropTypesShape,
  reaction: PropTypes.object.isRequired,
  zoom: PropTypes.number.isRequired,
  spinnerId: PropTypes.string.isRequired,
  originalSearchType: PropTypes.string,
  documentResults: PropTypes.bool,
  displayAllConditions: PropTypes.bool,
  databaseId: PropTypes.string.isRequired,
  showToolbar: PropTypes.bool,
  size: PropTypes.number,
};
